import { render } from "./GreenFlower.svg?vue&type=template&id=3ab69341"
const script = {}
script.render = render

export default script